import StorageService from '@/services/StorageService';

/**
 * Save the current avatar id
 * Uses the new avatar-scoped storage system with recent avatars tracking
 */
export const saveCurrentAvatarId = (currentAvatarId) => {
  if (!currentAvatarId) {
    return;
  }

  StorageService.updateRecentAvatars(currentAvatarId);
};

/**
 * Get the current avatar id
 * Returns the most recently used avatar from the recent avatars list
 */
export const getCurrentAvatarId = () => {
  const recentAvatars = StorageService.getRecentAvatars();
  return recentAvatars.length > 0 ? Number(recentAvatars[0]) : null;
};
